<template>
  <div class="w-full">

    <div v-for="project in projects" class="w-full pb-12">

      <div class="flex justify-between items-center w-full p-4 bg-white bg-opacity-[3%]">
        <div class="flex justify-start items-center space-x-4">
          <div class="w-10 h-10 rounded-md overflow-hidden">
            <img class="w-full h-full rounded-md" :src="project.project_logo" alt="" />
          </div>
          <h2 class="">{{ project.project }}</h2>
        </div>

        <div class="flex justify-end items-center sm:space-x-4 space-x-2">



          <div class="text-right">
            <p class="text-turquoise-500 text-xs">Amount Claimable</p>
            <p class="text-woodsmoke-200 font-light text-xs">{{ project.vesting?.amount_eth || "TBA" }}</p>
          </div>

          <div>
            <OTCBreakdown v-if="project.vesting" @onClickClaim="claim" :listings="project.listings.filter(o => o.concluded)" :vesting="project.vesting">
              <button class="btn min-h-0 h-auto py-2 btn-outline font-light border-white/10 btn-xs">Breakdown</button>
            </OTCBreakdown>
          </div>

          <button :disabled="!project.vesting" v-if="!project.vesting?.transaction_hash" @click="claim(project.vesting)"
            class="btn bg-white/5 text-turquoise-500 min-h-0 h-auto py-2">Claim</button>
          <a v-else-if="project.vesting?.transaction_hash" :href="getExplorer(project.vesting?.chain, project.vesting?.transaction_hash)" target="_blank"
            class="btn btn-link text-white">Claimed</a>
        </div>
      </div>

      <table class="hidden w-full sm:table table-auto">

        <thead class="bg-white/10 text-turquoise-500">

          <tr>
            <th class="font-normal">Action</th>
            <th class="font-normal">ID</th>
            <!-- <th class="font-normal">Project</th> -->
            <th class="font-normal">Pool</th>
            <th class="font-normal">Price (USDT)</th>
            <th class="font-normal">Allocation (USDT)</th>
            <th class="font-normal">Markup</th>
            <th class="font-normal">Effective %</th>
            <th class="font-normal">Owner</th>
            <th class="font-normal">Tx</th>
          </tr>

        </thead>


        <tbody>

          <tr v-for="list in project.listings" class="odd:bg-white/5">
            <td :class="['uppercase tracking-widest text-turquoise-500']">
              {{ list.action }}</td>
            <td>{{ list.id }}</td>
            <!-- <td>{{ _entries.project }}</td> -->
            <td>{{ list.pool }}</td>
            <td>{{ list.price }}</td>
            <td>{{ list.item.allocation?.amount }}</td>
            <td>{{ list.item.markup?.amount }}</td>
            <td>{{ list.effective_percent ? list.effective_percent : 'TBA' }}</td>
            <td>{{ list.owner.substring(0, 10) }}</td>
            <td>
              <span>{{ list.tx.substring(0, 10) }}</span>
              <a :href="`https://bscscan.com/tx/${list.tx}`" target="_blank"
                class="btn btn-link btn-xs text-turquoise-500">View</a>
            </td>
          </tr>


        </tbody>

      </table>

      <div v-for="list in project.listings"
        class="w-full sm:hidden grid grid-cols-6 p-4 border-b border-b-white/10 justify-center items-center">
        <div class="col-span-3">
          <div class="flex justify-start items-center space-x-2">
            <p
              :class="['uppercase tracking-widest', list.action == 'buy' ? 'text-blue-500' : '', list.action == 'sell' ? 'text-green-500' : '', list.action == 'refund' ? 'text-pink-500' : '']">
              {{ list.action }}</p>
            <p>ID: {{ list.id }}</p>
          </div>

        </div>

        <div class="col-span-3 flex justify-end items-center">
          <span>Tx: {{ String(list.tx).substring(0, 10) }}</span>
          <a :href="`https://bscscan.com/tx/${list.tx}`" target="_blank"
            class="btn btn-link btn-xs text-turquoise-500">View</a>
        </div>


        <div class="col-span-3 py-4">
          <p class="text-lg text-white">{{ list.pool }}</p>
          <p>Owner: {{ String(list.owner).substring(0, 10) }}</p>
        </div>

        <div class="col-span-3 py-4 text-right pr-2">
          <p class="text-white text-lg">Price: {{ list.price }} USDT</p>
        </div>

        <!-- <p class="text-woodsmoke-200 col-span-2">Markup: {{ list.markup }}</p>
        <p class="text-woodsmoke-200 col-span-2">Allocation: {{ list.allocation }} USDT</p>
        <p class="text-woodsmoke-200 col-span-2 text-right">Effective: {{ list.effective_percent ? list.effective_percent :
          'TBA' }}</p> -->
        <!-- <div class="col-span-3">

        </div>

        <div class="col-span-3">
        </div> -->

      </div>

    </div>

    <div class="p-4" v-if="!(projects.length > 0)">
      <p>No History</p>
    </div>



  </div>
</template>

<script setup>
import { getAccount, readContract, writeContract, waitForTransactionReceipt } from "@wagmi/core";
// import { config } from "~/wagmiConfig.js";

const { $wagmiConfig, $accessToken } = useNuxtApp()



const userStore = useUserStore();

//const entries = ref([])

//const grouped_entries = computed( () => {
//
//  let _grouped = {};
//
//  // group entries by attribute project
//
//  entries.value.forEach( (entry) => {
//    if(!_grouped[entry.project]){
//      _grouped[entry.project] = [];
//    }
//    _grouped[entry.project].push(entry);
//  })
//
//  // convert to array
//
//  return Object.keys(_grouped).map( (key) => {
//
//    console.log(_grouped[key][0])
//
//    return {
//      project: key,
//      project_logo: _grouped[key][0].project_logo,
//      entries: _grouped[key]
//    }
//  })
//
//})


const projects = ref([])

const estimateETHFee = async (address) => {
  console.log(address)
  try {
    const _fee = await readContract($wagmiConfig, {
      abi: [{
        "inputs": [],
        "name": "getCurrentFee",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      }],
      address,
      functionName: "getCurrentFee",
    });

    const etherFee = Number(_fee)
    // const scaleFactor = 10000;
    // const roundedNumber = Math.ceil(etherFee * scaleFactor) / scaleFactor;
    // return roundedNumber;
    return etherFee
  } catch (error) {
    return 0.005;
  }
};

const toast = useToast();
const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};

async function claim(vesting) {
  try {
    userStore.pauseUI = true;
    const ethFee = await estimateETHFee(vesting.refund_ca);

    const res = await writeContract($wagmiConfig, {
      address: vesting.refund_ca,
      functionName: "claim",
      args: [String(vesting.amount), JSON.parse(vesting.leaf)],
      abi: [{
        "inputs": [
          {
            "internalType": "uint256",
            "name": "_amount",
            "type": "uint256"
          },
          {
            "internalType": "bytes32[]",
            "name": "_merkleProof",
            "type": "bytes32[]"
          }
        ],
        "name": "claim",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      }],
      value: ethFee
    })

    const receipt = await waitForTransactionReceipt($wagmiConfig, {
      hash: res,
      confirmations: 2,
    });

    _toast({
      id: "claim",
      title: "Success!",
      description: "Successfully Claim",
      timeout: 5000,
    });
    userStore.pauseUI = false;
  } catch (err) {
    _toast({
      id: "claim",
      title: "Fail",
      description: "Unable To Claim",
      timeout: 5000,
    });
    console.error(err)
    userStore.pauseUI = false;
  }

}

async function renderHistory() {
  if ($accessToken.value) {
    const result = await $fetch(`/api/otc/history`, {
      headers: {
        'Authorization': `Bearer ${$accessToken.value}`
      }
    })

    //entries.value = result;
    projects.value = result;

  }
}

const getExplorer = (chain, txn) => {
  if (!chain) chain = 56;
  if (chain == 56) return `https://bscscan.com/tx/${txn}`;
  if (chain == 97) return `https://testnet.bscscan.com/tx/${txn}`;
  if (chain == 42161) return `https://arbiscan.io/tx/${txn}`;
  if (chain == 421613) return `https://goerli.arbiscan.io/tx/${txn}`;
  if (chain == 1) return `https://etherscan.io/tx/${txn}`;
  if (chain == 5) return `https://goerli.etherscan.io/tx/${txn}`;
  if (chain == 8453) return `https://basescan.org/tx/${txn}`;
  if (chain == 8453) return `https://sepolia.basescan.org/tx/${txn}`;
  if (chain == 137) return `https://polygonscan.com/tx/${txn}`;
  if (chain == 999) return `https://hyperliquid.cloud.blockscout.com/tx/${txn}`;
};

const unsub = userStore.$subscribe((state) => {
  renderHistory();
});

onMounted(() => {
  //let _account = getAccount(config);
  renderHistory();
});

onUnmounted(() => {
  unsub();
});


</script>

<style></style>